// extracted by mini-css-extract-plugin
export default {"menu":"NavBar_menu__1aNuR","buttons":"NavBar_buttons__fDSo4","Playlists":"NavBar_Playlists__ZbE5i","colors":"NavBar_colors__QuKYH"};